import { Grid, Paper } from '@mui/material';
import { useRef, useEffect, useState } from 'react';
import {
  ICommentActionProps,
  IProductComment
} from '../../types/ppg-sku-drawer.model';
import './index.scss';
import CommentInputControl from './comment-input-control';
import CommentItem from './comment-item';

interface IProductCommentsContainerProps extends ICommentActionProps {
  comments: IProductComment[];
  // eslint-disable-next-line react/require-default-props
  maxHeight?: number;
}
interface ICommentWrapperProps extends ICommentActionProps {
  comment: IProductComment;
}

function CommentWrapper({
  comment,
  onCommentUpdate,
  onCommentDelete,
  isActionVisible
}: ICommentWrapperProps) {
  // local state for setting isEdit mode enabled or not
  const [isEditModeEnabled, setIsEditModeEnabled] = useState(false);
  return (
    <Paper
      elevation={0}
      sx={{
        padding: '2px 4px',
        width: '100%',
        backgroundColor: '#F8F8F8',
        fontSize: '12px',
        border: '1px solid #dcdcdc',
        marginBottom: (theme) => theme.spacing(1)
      }}
    >
      {!isEditModeEnabled ? (
        <CommentItem
          comment={comment}
          isEditable={isActionVisible}
          onEdit={() => setIsEditModeEnabled(true)}
          onDelete={() => onCommentDelete(comment.pk_id)}
        />
      ) : (
        <CommentInputControl
          initialComment={comment.comment_text}
          onCommentAdd={(updatedComment) =>
            onCommentUpdate(comment.pk_id, updatedComment).then(() =>
              setIsEditModeEnabled(false)
            )
          }
        />
      )}
    </Paper>
  );
}

export default function ProductCommentsContainer({
  comments,
  onCommentUpdate,
  onCommentDelete,
  isActionVisible = true,
  maxHeight = 120
}: IProductCommentsContainerProps) {
  // for scrolling the comment list to top when comments exceeds the window height
  const gridRef = useRef(null);

  const scrollToTop = () => {
    gridRef.current.scroll({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    if (comments.length > 3) {
      scrollToTop();
    }
  }, [comments]);

  return (
    <Grid
      container
      spacing={1}
      pl={2}
      mt={1.2}
      maxHeight={maxHeight}
      overflow='auto'
      ref={gridRef}
    >
      {comments
        .slice()
        .sort(
          (a, b) =>
            new Date(b.updated_at).valueOf() - new Date(a.updated_at).valueOf()
        )
        .map((comment) => (
          <CommentWrapper
            isActionVisible={isActionVisible}
            key={comment.pk_id}
            comment={comment}
            onCommentDelete={onCommentDelete}
            onCommentUpdate={onCommentUpdate}
          />
        ))}
    </Grid>
  );
}
